import { FelaCSS, colors } from '@bridebook/ui';
import { ISharedProps as IStyleProps } from './section-heading';

interface IStyles {
  wrapper: FelaCSS;
}

const styles = ({ noMargin, largeMargin, lineHeight }: IStyleProps): IStyles => {
  const marginSize = largeMargin ? '16px' : '8px';

  return {
    wrapper: {
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: '0',
      marginBottom: noMargin ? '0' : marginSize,
      fontDefaultSemiBold: 20,
      lineHeight: lineHeight ? `${lineHeight}px` : '24px',
      color: colors.space,
    },
  };
};

export default styles;
